import React from 'react';
import { Link } from 'react-router-dom';
import Facebook from '../assets/images/Facebook';
import Twitter from '../assets/images/Twitter';
import LinkedIn from '../assets/images/linkedIn';
import Instagram from '../assets/images/Instagram';

const socialLink = [
  {
    name: 'Facebook',
    icon: <Facebook />,
    url: 'https://www.facebook.com',
  },
  {
    name: 'Twitter',
    icon: <Twitter />,
    url: 'https://x.com',
  },
  {
    name: 'LinkedIn',
    icon: <LinkedIn />,
    url: 'https://www.linkedin.com',
  },
  {
    name: 'Instagram',
    icon: <Instagram />,
    url: 'https://www.instagram.com',
  },
];

const ResourceUptoDate = () => {
  return (
    <div className="resource-date" data-aos="fade-up">
      <div className="resource-data-title" data-aos="fade-up">
        <h2>Stay up to date with latest at legalligence</h2>
      </div>
      <div className="resource-media">
        {socialLink.map((item, index) => (
          <Link
            to={item.url}
            target="_blank"
            rel="noopener noreferrer"
            key={'social-' + index}
            className="icon-wrapper"
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
            data-aos-duration="800"
          >
            {item.icon}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ResourceUptoDate;
